import {
  DEFAULT_AGE_QUOTA_CRITERIA,
  FeasibilityCriterion,
  QUALIFICATION_CODE,
  SurveyQualification,
} from '@ps/survey-utils';

import { FeasibilityCriteriaMapperBase } from '../../../utils/feasibility-criteria-mapper.base';

/** The display model: audience labels, quota-row labels, unused-qualification analysis. */
export class FeasibilityCriteriaMapper extends FeasibilityCriteriaMapperBase<FeasibilityCriterion> {
  protected override toCriterion(
    qualification: SurveyQualification,
  ): FeasibilityCriterion {
    if (qualification.isRangeType) {
      return {
        qualificationCode: qualification.qualificationCode,
        qualificationName: qualification.qualificationName,
        rangeSets: qualification.rangeSets,
      };
    }

    return {
      qualificationCode: qualification.qualificationCode,
      qualificationName: qualification.qualificationName,
      conditionCodes: qualification.conditionCodes,
      conditionNames: qualification.data.map((datum) => datum.name),
    };
  }

  protected override defaultAgeCriterion(): FeasibilityCriterion {
    return {
      qualificationCode: QUALIFICATION_CODE.AGE,
      qualificationName: DEFAULT_AGE_QUOTA_CRITERIA.NAME,
      rangeSets: [
        {
          from: DEFAULT_AGE_QUOTA_CRITERIA.MIN,
          to: DEFAULT_AGE_QUOTA_CRITERIA.MAX,
          units: DEFAULT_AGE_QUOTA_CRITERIA.UNITS,
        },
      ],
    };
  }
}
